<template>
<div>
  <div class="nav">
    <div class="sn-nav-back">
      <a class="sn-iconbtn" href="javascript:history.go(-1);">返回</a>
      <div class="title">{{storeData.storeInfo.name}}</div>
      <div name="o2o_dianqi_guanzhu_01" class="focus" v-if="focus.on && !storeData.empty" @click="focusStore" :class="{act:focus.state == '1'}"></div>
    </div>
  </div>
  <div id="store-page" v-if="!storeData.empty">
    <div class="shop-detail" v-if="storeData.storeHeadPhotoList">
      <div class="shop-pic" :class="[{'default-logo': storeData.storeHeadPhotoList.length}, 'store-type-' + storeType]">
        <img v-if="storeData.storeHeadPhotoList.length" :src="storeData.storeHeadPhotoList[0].imgUrl | urlProtocol" alt="">
      </div>
      <div class="shop-intro">
        <h2>{{storeData.storeInfo.name}}</h2>
        <a :href="storeData.storeAdress">
          <div class="shop-address">{{storeData.storeInfo.address}}</div>
        </a>
        <ul v-if="storeData.storeInfo.storeLabel !== ''">
          <li v-for="item in storeData.labelList"><p>{{item}}</p></li>
        </ul>
      </div>
    </div>
    <!--热门活动-->
    <div class="hot-active" v-if="storeData.storeActivityList && storeData.storeActivityList.length">
      <h2 class="sub-title">热门活动 <a v-if="storeData.storeActivityCount > 2" @click="skipActList" name="o2o_dianqi_huodong_02">查看全部</a></h2>
      <ul>
        <li v-for="(item,index) in storeData.storeActivityList.slice(0,2)" name="o2o_dianqi_huodong_01">
          <a :href="item.activityUrl">
            <div class="act-item-pic">
              <img :src="item.activePicUrl | urlProtocol" alt="">
            </div>
            <div class="act-item-intro">
              <div class="act-item-title clearfix">
                <span>{{item.activeType}}</span>
                <h2>{{item.activityDesc}}</h2>
              </div>
              <div class="act-item-time">时间：{{item.activityStartTime|formatDate}} — {{item.activityEndTime|formatDate}}</div>
            </div>
          </a>
        </li>
      </ul>
    </div>
    <!--门店评价-->
    <div class="store-evaluate" v-if="evaluateList.length > 0">
      <h2 class="sub-title">门店评价 <a @click="skipEval" name="o2o_dianqi_pingjia_01">全部<span>{{evalCount}}</span>条评论</a></h2>
      <ul>
        <li v-for="(item, index) in evaluateList" class="evaluate-item">
          <div class="evaluate-item-info">
            <p>{{item.nikeName}}对{{item.guideName}}的评价</p>
            <span>{{item.evalTime}}</span>
          </div>
          <div class="evaluate-item-desc">{{item.content}}</div>
        </li>
      </ul>
    </div>
    <template v-if="navList.length > 0">
      <CateNav :navList="navList"  @listenChild="receiveType"></CateNav>
      <div class="productList" v-if="prdList.length > 0">
        <ul class="clearfix">
          <li v-for="(item, index) in prdList" @click="skipInfo(item.itemImg,item.itemName,item.salesVolume,item.itemCode)" name="o2o_dianqi_shangpin_01">
            <img :src="item.itemImg | urlProtocol" alt="">
            <p>{{item.itemName}}</p>
            <span v-if="item.salesVolume !== ''">本店可售</span>
          </li>

        </ul>
      </div>
      <NoonInfo v-if="!prdList.length > 0" :msg="'暂无商品数据，敬请期待'"></NoonInfo>
    </template>
    <div class="load" v-show="prdList.length > 0">
      <div class="sn-loading-type">
        <span class="sn-pull-loading hide">上拉精彩无限</span>
        <div class="sn-end-loading hide"><span>没有更多了</span></div>
      </div>
      <div class="loadmore" data-loaded=""></div>
    </div>
    <div class="bottom fixed">
      <div class="tel" v-if="storeData.storeInfo.telephone" :class="{'only-tel': !storeData.guideInfo}">
        <a :href="'tel:' + storeData.storeInfo.telephone">
          <p>电话联系</p>
        </a>
      </div>
      <div class="guid" v-if="storeData.guideInfo" name="">
        <a :href="storeData.guideInfo.weeklyTopGuiderUrl">
          <img :src="storeData.guideInfo.guidePhoto | urlProtocol" alt="">
          <div class="guid-info">
            <h2>{{storeData.guideInfo.guideName}}</h2>
            <p>预约导购到门店</p>
          </div>
        </a>
      </div>
    </div>
  </div>
  <NoonInfo v-if="storeData.empty" :msg="'抱歉，本店已经停止营业，敬请谅解'"></NoonInfo>
  <input type="hidden" id="pagename" value="pgcate=10009;tag=100043;pgtitle=身边苏宁-电器店主页">
</div>
</template>

<script>
  import CONF from '@/app.conf.json'
  import Server from '@/services/Entrance'
  import CateNav from '@/components/commons/CateNav'
  import NoonInfo from '@/components/commons/NoonInfo'
  import {Util} from '../commons/util'

  export default{
  	name:'StoreHome',
    data() {
  		return {
  			storeType: '',
  			storeCode: '',
  			cityCode: '',
        focus: {
  				on:false,
          state:''
        },
        storeData:{
  				empty: false,
          storeInfo:{
  					name: ''
          }
        },
        evaluateList:[],
  			evalCount:'',
  			curCatalogueId:'',
        navList:[],
        prdList:[],
        pageNum: 1,
        loadable: false

      }
    },
    components: {
      CateNav,
      NoonInfo
    },
    mounted(){
      document.title="门店主页";
      window.scrollTo(0,0);

  		let _this = this,
        params = _this.$route.params;
      let storeType = _this.storeType = params.storeType,
          storeCode = _this.storeCode = params.storeCode;
      _this.cityCode = params.cityCode;

  		/*门店基础信息*/
  		Server.storepage.queryStoreInfo(storeCode).then(data => {
  			console.log(data)
        if(data.code === '1'){
          _this.storeData.empty = true;
          return;
        }
        let storeData = data.data;
        if(!data.data.storeInfo.hasOwnProperty('storeId')){
          _this.storeData.empty = true;
          return false;
        }else {

          if(storeData.storeInfo.storeLabel !== ''){
            storeData.labelList = storeData.storeInfo.storeLabel.split(',');
          }
          if(storeData.storeInfo.telephone !== ''){
            storeData.storeInfo.telephone = storeData.storeInfo.telephone.split(';')[0];
          }
          storeData.storeAdress = CONF.otherPage.storeAddress.replace('{{storeId}}',storeCode)

          _this.storeData = storeData;

          //除维修店外，其他门店可关注
          if(storeType !== '8'){
            _this.focus.on = true;

            $.probeAuthStatus(function () {

              Server.storepage.queryFocusStore(_this.storeCode).then(data => {

                if(data.data.hasOwnProperty('attType')){
                  _this.focus.state = data.data.attType;
                }else {
                  _this.focus.state = '0';
                }
//                _this.focus.state = data.data.attType;

              })
            }, function () {

              console.log('UnLogin')

            }, CONF.PASSPORT.CONFIG);
          }

          //电器店和红孩子展示评价数据
          if(storeType === '1'){
            Server.common.queryEvaluate(storeCode,1).then(data => {
              console.log(data)
              if(data.totalCount > 0){
                _this.evaluateList = data.evaluateList.slice(0,2)
                _this.evalCount = data.totalCount;
              }
            })
          }

          console.log(storeType)
          //判断门店类型，调取数据
          switch (storeType){
            //电器店 8727
            case "1":{
              /*查询TAB切*/
              Server.storepage.queryBeterTabs(storeCode,_this.cityCode).then(data => {
                if(data.code === '0'){
                  let arr = data.data,
                    navList = [];

                  for(let i = 0;i < arr.length;i++){
                    let item = {
                      parameterId: arr[i].catalogueId,
                      parameterName: arr[i].catalogueName
                    }
                    navList.push(item);
                  }
                  this.navList = navList;
                }
              });
              break
            }
            //苏宁红孩子 精选店（零售） 5 9
            case "5": case "9": {
            //不同业态查询tab切类，跳转固定code
            	let code;
              if(storeType === '5'){
                code = '1041'
              }else if(storeType === '9'){
                code = '1042'
              }

              /*查询TAB切*/
              Server.storepage.queryRedTabs(code).then(data => {
                if(data.code === '0'){
                  _this.navList = data.data;
                }
              });
              break
            }
            //维修中心37
            case "8": {
              Server.storepage.queryRepairTabs(storeCode).then( data => {
                if(data.code === '0'){
                  let arr = data.data,
                    navList = [];

                  for(let i = 0;i < arr.length;i++){
                    let item = {
                      parameterId: arr[i].iconId,
                      parameterName: arr[i].iconName
                    }
                    navList.push(item);
                  }
                  _this.navList = navList;
                }
              })
              break
            }
            //优趣店 体育店 1045
            case"13": case"14": {
            	//不同业态查询tab切类，跳转固定code
              let code;
              if(storeType === '13'){
                code = '1045'
              }else if(storeType === '14'){
                code = '1047'
              }

              Server.storepage.queryYouTabs(code).then( data => {
                if(data.code === '0'){
                  _this.navList = data.data;
                }
              })
              break
            }
          }
        }
      })
    },
    methods: {
    	//导航关注门店
      focusStore(){
      	let _this = this,
      	     focus = _this.focus,
              params = {
                storeCode: _this.storeCode
              }


        $.probeAuthStatus(function () {

        	//已登录执行方法
          if(focus.state === '0'){
            Server.storepage.addFocusStore(params).then(data => {
              if(data.code === '0'){
                focus.state = '1';
                AlertBox({
                  type: 'mini',
                  msg: '您已成功关注该门店，您下次可优先查看本店信息'
                })
              }else if(data.code === '0010'){
                AlertBox({
                  type: 'mini',
                  msg: data.msg
                })
              }
            })
          }else {
            AlertBox({
              type: 'doubleBtn',
              alertType: 'fixed',
              confirmText: '确定',
              cancelText: '再想想',
              msg: '您确定取消关注该门店',
              confirm: function () {
                Server.storepage.delFocusStore(params).then(data => {
                  if(data.code === '0'){
                    focus.state = '0';
                  }
                })
              },
              cancel: function () {

              }
            });
          }
          _this.focus = focus

        }, function () {
        	//未登录执行
          Util.redirectToLogin();
        }, CONF.PASSPORT.CONFIG);

      },
      receiveType(e){

        let _this = this,
            cateId = _this.curCatalogueId = e.catalogueId,
            storeCode = _this.storeCode;


        console.log('cateId',cateId)

        // lazyload分页加载
        let $loadMore = $(".loadmore"),
          $pullLoading = $(".sn-pull-loading"),
          $snEndLoading = $(".sn-end-loading");

        switch (_this.storeType){
        	//电器城
          case '1' :{
        		Server.storepage.queryBeterList(storeCode, _this.cityCode, cateId).then( data => {

              $snEndLoading.show()
              $pullLoading.hide();


        			if(data.code == '0'){
                let arr = data.data,
                  prdList = [],
                  imgUrl = '';
                for (let i = 0;i < arr.length;i++){

                  let item = {},
                      prdCode, //商品编码
                      venderCode;//供应商编码

                  //商品名称
                  item.itemName = arr[i].sugGoodsName;
                  //商品编码
                  item.itemCode = arr[i].sugGoodsCode;
                  //销量
                  if(arr[i].hasOwnProperty('salesVolume')){
                    item.salesVolume = arr[i].salesVolume
                  }else {
                    item.salesVolume = ''
                  }

                  //获取商品图片
                  prdCode = arr[i].sugGoodsCode;

                  imgUrl = $.base.getNewProductImg({
                    proCode: prdCode,
                    vendorCode: '0000000000',
                    size: 400
                  })

                  item.itemImg = imgUrl;

                  prdList.push(item)
                }
                _this.prdList = prdList;
              } else {
                _this.prdList = [];
              }
//              console.log(_this.prdList)
            });
            break
          }

          /*红孩子商、精选店、优趣店、体育店  商品列表*/
          case '5': case'9': case'13': case '14': {

          	_this.pageNum = 1;
            _this.loadable = false;

            $loadMore.attr('data-loaded','')
            function loadList(el) {

              let cateId = _this.curCatalogueId
              let pageNum = _this.pageNum

              Server.storepage.queryRedList(storeCode, cateId, pageNum).then(data => {
                if(data.code === '0'){
                  let prdList = data.data;

                  //遍历图片地址
                  for(let i = 0;i < prdList.length;i++){
                    prdList[i].itemImg = $.base.getNewProductImg({
                      proCode: prdList[i].itemCode,
                      vendorCode: '0000000000',
                      size: 400
                    });
                  }
                  console.log(prdList)
                  if(pageNum == '1'){
                    _this.prdList = prdList
                  }else {
                    _this.prdList = _this.prdList.concat(prdList);
                  }
                  _this.loadable = true;
                  _this.pageNum++
//                  el.attr("data-loaded", "");
                } else {
                  $snEndLoading.show();
                  $pullLoading.hide();
                  if(pageNum == '1'){
                    _this.prdList = [];
                  }
                  $loadMore.attr("data-loaded", "done");

                  return false;
                }

                $pullLoading.show();
              });
            }

          $loadMore.lazyload(function (el) {
//          	console.log(el)
            let pageNum = _this.pageNum;

            if(!_this.loadable){
              return;
            }

            _this.loadable = false;

            loadList(el);

          });

          //初始加载
          loadList();

            break;
          }

          /*维修中心商品列表*/
          case '8':{

            $snEndLoading.show()
            $pullLoading.hide();

          	//cateId 37
            Server.storepage.queryRepairList(cateId).then( data => {
              //遍历图片地址
              if(data.code === '0'){
                let prdList = data.data;
                for(let i = 0;i < prdList.length;i++){
                  prdList[i].itemImg = $.base.getNewProductImg({
                    proCode: prdList[i].itemCode,
                    vendorCode: '0000000000',
                    size: 400
                  });
                }
                _this.prdList = prdList;
              } else {
                _this.prdList = []
              }
//              console.log(prdList)
            });
          	break;
          }
        }

      },
      //跳转商品参数页
      skipInfo(url,desc,sale,code){
//      	console.log(this.storeCode)
      	if(this.storeType === '8'){
      		window.location.href = CONF.otherPage.repairCenter.replace('{{storeId}}',code)
        }else {
          let storage = Util.getLocalStorage();
          storage.setItem('prdUrl',url);
          storage.setItem('prdDesc',desc);
          if(sale === ''){
            storage.setItem('prdSale', false);
          } else{
            storage.setItem('prdSale', sale);
          }
          storage.setItem('cityCode',this.cityCode)
          this.$router.push({
            name: 'ProductInfo',
            params: {
              prdCode: code
            }
          });
        }

      },
      //跳转评价展示页
      skipEval(){
        this.$router.push({
          name: 'Evaluate',
          params: {
            storeCode: this.storeCode
          }
        });
      },

      skipActList(){
      	window.location.href = CONF.otherPage.activeList.replace('{{storeId}}', this.storeCode)
      }

    }
  }
</script>

<style scoped="">
  #store-page{
    background: #f2f2f2;
    max-width: 750px;
    font-size: 24px;
    color: #444444;
  }
  .nav{
    background: #ff9900;
  }
  .sn-nav-back{
    z-index: 9;
    margin: 0;
    border-bottom: 0;
    position: relative;
    height: 1.76rem;
    line-height: 1.76rem;
    font-size: 34px;
    width: 100%;
    a{
      height: 1.76rem;
    }
    .focus{
      /*border: 1px solid;*/
      position: absolute;
      background: url('../assets/focus.png') no-repeat center;
      background-size: 40px 40px;
      top: 24px;
      right: 30px;
      height: 40px;
      width: 40px;
    }
    .focus.act{
      background: url('../assets/focus_act.png') no-repeat center;
      background-size: 40px 40px;
    }
  }
  .sn-nav-back:before{
    border: solid #fff;
    border-width: 3px 0 0 3px;
    -webkit-transform: rotate(-45deg);
    left: .56rem;
  }
  .title{
    font-family:PingFangSC-Medium;
    text-align: center;
    color:#ffffff;
  }

  .shop-detail,.hot-active,.store-evaluate,.productList{
   background: #ffffff;
  }
  .shop-detail{
    height: 200px;
    padding: 20px;
    .shop-pic{
      width: 160px;
      height: 160px;
      display: block;
      margin: 0 20px 0 0;
      float: left;
        @for $i from 1 to 14 {
          &.store-type-$i {
            background: url("../assets/store-type-$(i).jpg") 0 0 no-repeat;
            background-size: 100%;
          }
        }

        &.store-type-undefined {
            background: url("../assets/store-type-8.jpg") 0 0 no-repeat;
            background-size: 100%;
        }
      img{
        width: 160px;
        height: 160px;
      }
    }
    .shop-intro{
      width: 520px;
      height: 160px;
      float: left;
      h2{
        font-weight: 600;
        font-size: 32px;
        color: #333333;
        line-height: 45px;
      }
      .shop-address{
        position: relative;
        font-size: 26px;
        line-height: 37px;
        color: #999999;
        margin: 14px 0;
        padding: 0 26px 0 35px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        &:before{
          content: '';
          display: block;
          background: url("../assets/loca-icon.png") no-repeat center;
          background-size: 18px 24px;
          width: 20px;
          height:37px;
          position: absolute;
          left: 0;
         }
         &:after{
            content: "";
            position: absolute;
            top: 10px;
            right: 10px;
            display: inline-block;
            width: .28rem;
            height: .28rem;
            border: solid #999999;
            border-width: 1px 0 0 1px;
            -webkit-transform: rotate(135deg);
          }
      }
      ul{

        li{
          display: table;
          float: left;
          /*width: 120px;*/
          height: 36px;
          margin: 0 10px 0 0;
          padding: 0 10px;
          border: 1px solid #CCCCCC;
          border-radius: 2px;
          p{
            display: table-cell;
            vertical-align: middle;
            text-align: center;
          }
        }
      }

    }
  }
  .sub-title{
    font-size: 28px;
    line-height: 34px;
    a{
      float: right;
      position: relative;
      color: #999999;
      font-size: 24px;
      padding: 0 40px 0 0;
      &:after{
         content: "";
         position: absolute;
         top: 7px;
         right: 5px;
         display: inline-block;
         width: .28rem;
         height: .28rem;
         border: solid #999999;
         border-width: 1px 0 0 1px;
         -webkit-transform: rotate(135deg);
       }
      span{
        color: #FFAA00;
      }
    }
  }
  .hot-active{
    margin: 20px 0 0 0;
    padding: 16px 20px 20px;
    ul{
      li{
        height: 140px;
        width: 710px;
        padding: 20px 0;
      }
    }
  }
  .act-item-pic{
    /*border: 1px solid;*/
    float: left;
    height: 100px;
    width: 160px;
    img{

    }
  }
  .act-item-intro{
    height: 100px;
    width: 530px;
    float: right;
  }
  .act-item-title{
    span{
      float: left;
      background: #FFAA00;
      font-size: 20px;
      line-height: 30px;
      text-align: center;
      color: #ffffff;
      font-weight: normal;
      width: 70px;
      height: 30px;
      border-radius: 3px;
      margin: 10px 8px 0 0;
    }
    h2{
      float: left;
      width: 450px;
      font-size: 30px;
      line-height: 50px;
      color: #222222;
      font-weight: bold;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }
  }
  .act-item-time{
    height: 50px;
    line-height: 50px;
    color: #999999;
  }
  #cate-nav{
    margin: 20px 0 0 0;
  }
  .store-evaluate{
    margin: 20px 0 0 0;
    padding: 16px 20px 0;
    ul{
      li{
        width: 100%;
        border-bottom: solid 1px #f2f2f2;
      }
      li:last-child{
        border-bottom: 0;
      }
    }
  }
  .evaluate-item{
    padding: 20px 0;
  }
  .evaluate-item-info{
    font-size: 24px;
    color: #999999;
    margin: 0 0 10px 0;
    line-height: 35px;
    height:35px;
    p{
      display: inline-block;
    }
    span{
      float: right;
    }
  }
  .evaluate-item-desc{
    font-size: 28px;
    color: #222222;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
  }
  .productList{
    ul{

    }
    li{
      float: left;
      width: 374px;
      height:460px;
      border-bottom: solid 1px #f2f2f2;
      position: relative;
      padding:20px;
      img{
        width: 334px;
        height: 334px;
      }
      p{
        margin: 15px 0 0 0;
        font-size: 24px;
        color: #222222;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
      }
      span{
        background: #FFAA00;
        color: #ffffff;
        display: block;
        width: 142px;
        height: 40px;
        text-indent: 20px;
        line-height: 40px;
        position: absolute;
        bottom: 105px;
        left: 0;
        border-radius: 0 40px 40px 0;
      }
    }
    li:nth-child(2n){
      border-left: solid 1px #f2f2f2;
    }
  }
  .base-line {
    background: #f2f2f2;
    position: relative;
    color: #999;
    height: 2rem;
    line-height: 2rem;
    text-align: center;
    margin: 0 0 2rem 0;
    &:before,&:after{
       content: "";
       position: absolute;
       background: #ccc;
       height: 1px;
       width: 4rem;
       top: 50%;
     }
    &:before{
      left: 1rem;
     }
    &:after{
     right: 1rem;
    }
  }
  .bottom{
    position: fixed;
    bottom: 0;
    left:0;
    width: 100%;
    background: #ffffff;
  }
  .tel{
    margin: 0 auto;
    float: left;
    width: 50%;
    height: 100px;
    p{
      /*width: 50%;*/
      margin: auto 0;
      text-align: center;
      font-size: 20px;
      position: relative;
      color: #444444;
      padding: 50px 0 0 0;
      &:before{
          content: '';
          display: block;
          background: url("../assets/Phone.png");
          background-size: 26px 36px;
          position: absolute;
          top: 16px;
          left: 50%;
          margin-left: -13px;
          width: 26px;
          height: 36px;
          /*border: 1px solid;*/
       }
    }
  }
  .only-tel{
    float: none;
  }
  .guid{
    background: #FFAA00;;
    display: block;
    float: right;
    width: 50%;
    height: 100px;
    img {
      float: left;
      margin: 10px 20px;
      width: 80px;
      height: 80px;
      border-radius: 80px;
      /*border: 1px solid;*/
    }
    .guid-info{
      float: left;
      margin: 10px 0 10px 20px;
      width: 210px;
      height:80px;
      &:before{
         content: "";
         position: absolute;
         top: 0.8rem;
         right: 0.4rem;
         display: inline-block;
         width: .28rem;
         height: .28rem;
         border: solid #ffffff;
         border-width: 1px 0 0 1px;
         -webkit-transform: rotate(135deg);
       }
    }
    p,h2{
      color: #FFFFFF;
    }
    p{
      font-size: 24px;
    }
    h2{
      font-size: 30px;
    }
  }
  .load{
    margin: 0 0 100px 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/StorePage.vue